import { Box, Stack } from '@mui/material';
import { useMixpanel } from 'react-mixpanel-browser';

import { useSubscriptionsInfo } from '@/api/subscriptions';
import { AlertChip } from '@/components/AlertChip';
import { Timestamp } from '@/components/data/Timestamp';
import { SummaryCard, SummaryCardBody, SummaryCardButton } from '@/components/ui/SummaryCard';

export const CurrentSubscriptionPeriodCard = () => {
    const { data: subscriptionInfo, isPending: isSubscriptionInfoPending } = useSubscriptionsInfo();
    const subscription = subscriptionInfo?.data?.[0];
    const mixpanel = useMixpanel();
    const isSubscriptionPastDue = subscription?.status === 'past_due';
    const showPayInvoiceButton = isSubscriptionPastDue && !!subscription?.hosted_invoice_url;
    const isOnBillingPage = location.pathname.match(/\/billing\b/);
    const { label, href } = isOnBillingPage
        ? { label: 'Preview invoice', href: '/payment' }
        : { label: 'View all invoices', href: '/billing' };

    const handleReceiptViewClick = () => {
        mixpanel?.track('Stripe ovedue invoice viewed', { status: subscription?.status });
    };

    return (
        <SummaryCard
            title="Current invoice period"
            isLoading={isSubscriptionInfoPending}
            data-testid="current-invoice-period-content"
        >
            <SummaryCardBody>
                {subscription ? (
                    <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
                        <Box>
                            <Timestamp value={subscription?.current_period_start} unit="date" type="medium" />
                            {' - '}
                            <Timestamp value={subscription?.current_period_end} unit="date" type="medium" />
                        </Box>
                        {isSubscriptionPastDue && <AlertChip severity="error" label="Overdue" />}
                    </Stack>
                ) : (
                    'N/A'
                )}
            </SummaryCardBody>
            {showPayInvoiceButton ? (
                <SummaryCardButton onClick={handleReceiptViewClick} href={subscription?.hosted_invoice_url}>
                    Pay invoice
                </SummaryCardButton>
            ) : (
                <SummaryCardButton href={href}>{label}</SummaryCardButton>
            )}
        </SummaryCard>
    );
};
